var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.asButton)?_c('RouterLink',_vm._g(_vm._b({},'RouterLink',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_c('MButton',_vm._g(_vm._b({on:{"click":function($event){return _vm.$router.push(_vm.$attrs.to)}}},'MButton',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }